/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryDictList(data) {
            return http.json({
                url: '/sys/dict/query',
                data
            })
        },


        queryRepairCategoryDictList(){
            return http.json({
                url: '/sys/dict/queryByCodeEqRepairCategory?code=repairCategory',
            })
        },
        /**
         * 获取字典详情
         * @param data
         * @return {*}
         */
        getDictInfo(data) {
            return http({
                url: `/sys/dict/get?id=${data.id}`,
                method: 'post'
            })
        },


        /**
         * 保存字典信息
         * @param data
         * @return {*}
         */
        saveDictInfo(data) {
            return http.json({
                url: '/sys/dict/save',
                data
            })
        },

        /**
         * 删除字典
         * @param data
         * @return {*}
         */
        removeDict(data) {
            return http.json({
                url: '/sys/dict/delete',
                data
            })
        },


        queryTreeByPayType(data) {
            return http.json({
                url: '/sys/dict/queryTreeByPayType',
                data
            })
        },

        queryTreeByBreakType(data) {
            return http.json({
                url: '/sys/dict/queryTreeByBreakType',
                data
            })
        },


        queryTreeByCheXing(data) {
            return http.json({
                url: '/sys/dict/queryTreeByCheXing',
                data
            })
        },


        queryTreeByOutName(data) {
            return http.json({
                url: '/sys/dict/queryTreeByOutName',
                data
            })
        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/dict.js